var _circle, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMsPersonSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 3,
    fill: "#FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13C8.3911 13 5.59621 15.3257 5.08417 17.0395C4.9828 17.3788 5.09238 17.7335 5.31256 18.0108C6.04703 18.9359 8.12047 21 12 21C15.8795 21 17.953 18.9359 18.6874 18.0108C18.9076 17.7335 19.0172 17.3788 18.9158 17.0395C18.4038 15.3257 15.6089 13 12 13Z",
    fill: "#FFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    transform: "rotate(90 12 12)",
    stroke: "#FFF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMsPersonSelected);
export default __webpack_public_path__ + "static/media/ic_ms_person_selected.9645257a6df73302af4d516eed0a3e58.svg";
export { ForwardRef as ReactComponent };